import { DomEvent } from "leaflet"

export const disablePropagation = (element: HTMLElement | null) => {
    if (element) {
        DomEvent.disableClickPropagation(element).disableScrollPropagation(element)
    }
}
